import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'SelectServiceNoticeTypeModal',
  components: {
    Loading
  },
  data () {
    return {
      loading: true,

      // テーブルオプション
      tableColumns: [
        'checkbox',
        'noticeTypeMstId',
        'noticeTypeName',
        'noticeType',
        'noticeTypeStatus',
      ],
      tableData: [],
      tableOptions: {
        headings: {
          checkbox: '',
          noticeTypeMstId: 'お知らせタイプID',
          noticeTypeName: 'お知らせタイプ名',
          noticeType: '配信タイプ',
          noticeTypeStatus: 'ステータス',
        },
        columnsClasses: {
          checkbox: 'wp-3',
          noticeTypeMstId: 'wp-5',
          noticeTypeName: '',
          noticeType: '',
          noticeTypeStatus: '',
        },
        sortable: [
          'noticeTypeMstId',
          'noticeTypeName',
          'noticeType',
          'noticeTypeStatus'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts('配信タイプ'),
        perPage: Constants.TableOptions.perPage.modal,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // チェックリスト
      checkList: []
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      active: state => state.selectServiceNoticeTypeModal.active,

      // form
      serviceId: state => state.selectServiceNoticeTypeModal.serviceId,
      deliveryTypes: state => state.selectServiceNoticeTypeModal.deliveryTypes,
      value: state => state.selectServiceNoticeTypeModal.value,

      // model
      noticeTypeMstModel: state => state.selectServiceNoticeTypeModal.noticeTypeMstModel,
      serviceDeliveryTypeModel: state => state.selectServiceNoticeTypeModal.serviceDeliveryTypeModel,
    }),
    ...mapGetters({
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    disableConfirmButton () {
      return this.checkList.length === 0
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'selectServiceNoticeTypeModal/loadModel',
      hide: 'selectServiceNoticeTypeModal/hide',
      setValue: 'selectServiceNoticeTypeModal/setValue',
      reset: 'selectServiceNoticeTypeModal/reset'
    }),

    init () {
      this.loading = true

      // storeをリセット
      // this.reset()

      // 選択済みサービス配信タイプUUIDをチェックリストに格納
      if (this.value &&
        this.value.length) {
        let data = $.extend(true, [], this.value)
        this.$set(this, 'checkList', data)
      }

      // データ読出し
      this.loadModel()
        // eslint-disable-next-line
        .then(res => {
          this.loading = false

          // 「配信タイプとお知らせタイプとの紐付けデータ」から
          // 指定された複数の配信タイプに属するお知らせタイプのuuidを取得して配列に格納
          let noticeTypeUuids = []
          this.serviceDeliveryTypeModel
            .filter(item => this.deliveryTypes.indexOf(item.deliveryType) !== -1)
            .forEach(item => {
              item.noticeTypeInfo.forEach(noticeType => {
                if (!noticeTypeUuids.length ||
                  noticeTypeUuids.indexOf(noticeType.noticeTypeMstUuid) === -1) {
                  noticeTypeUuids.push(noticeType.noticeTypeMstUuid)
                }
              })
            })

          // お知らせタイプのuuidリストからお知らせタイプデータを取得
          let list = []
          if (noticeTypeUuids.length) {
            noticeTypeUuids.forEach(uuid => {
              const item = this.noticeTypeMstModel.filter(item => item.noticeTypeMstUuid === uuid)[0]
              list.push(item)
            })
          }
          console.log('noticeTypes', list)

          this.tableData = $.extend(true, [], list)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'checkbox':
          // return props.row.noticeTypeMstUuid
          return props.row.noticeType
        case 'noticeTypeStatus':
          return Utility.getConstantsLabel(['Status'], value)
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    selectItem (props) {
      console.log(this.checkList)

      // 選択されたファイル情報をstoreに保持
      this.setValue(this.checkList)

      this.closeModal()
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}